import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import ThemeProvider from 'hb-react/style/ThemeProvider';

export const GenericErrorBanner = ({
  resetError,
  theme = 'bo',
}: {
  resetError: () => void;
  theme?: 'bo' | 'fo' | 'po';
}) => (
  <ThemeProvider theme={theme}>
    <Box
      width="100%"
      maxWidth="920px"
      margin="auto"
      justifyContent="center"
      flexDirection="column"
      py={4}
    >
      <SimpleCard
        cardProps={{ width: '100%' }}
        title={s__(
          'ErrorBoundary|Sorry, something went wrong. Our team has been notified.',
        )}
        faIconProps={{
          iconName: 'user-robot-xmarks',
        }}
        description={
          <Box mt={4} flexDirection="column" font="h4-regular">
            {s__('ErrorBoundary|Here is what you can do:')}

            <Box pt={4} justifyContent="center">
              <Button
                onClick={() => {
                  resetError();
                }}
                mr={1}
              >
                {s__('ErrorBoundary|Reload the page')}
              </Button>
            </Box>
          </Box>
        }
      />
    </Box>
  </ThemeProvider>
);
